$(document).ready(function() {
  $("aside.side-menu .item-toggler").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find("ul").slideToggle("fast");
  });
});
